module.exports = __webpack_public_path__ + "static/media/x-23-lose.e8d65a68.png";